/* ARTHEN — subtle scroll reveal. Performance-first, no libraries.
   Only off-screen sections get the reveal class, so nothing above the fold
   flashes and there is no no-JS penalty (class is JS-added). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    sections.forEach(function (sec, i) {
      // Leave the first sections (hero) untouched to avoid above-fold flash
      if (i < 1) return;
      // Skip anything already within (or near) the viewport on load
      if (sec.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      sec.classList.add('arthen-reveal');
      io.observe(sec);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
